"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const format_1 = __importDefault(require("../utils/format"));
const isValid_1 = __importDefault(require("../utils/isValid"));
const unformat_1 = __importDefault(require("../utils/unformat"));
function useRut(defaultValue = '') {
    const [state, setState] = react_1.default.useState({
        formattedValue: defaultValue,
        isValid: isValid_1.default(defaultValue),
        rawValue: defaultValue
    });
    const setRut = react_1.default.useCallback((value) => {
        setState({
            ...state,
            formattedValue: format_1.default(value),
            isValid: isValid_1.default(value),
            rawValue: unformat_1.default(value)
        });
    }, [state, setState]);
    return [
        state,
        setRut
    ];
}
exports.default = useRut;
//# sourceMappingURL=useRut.js.map